import * as commService from '../services/commService';

export default {
  namespace: 'common',

  state: {
    userInfo: null,
    dictAll: [],
    smsTemplateListData: {
      data: [],
      total: 0,
      pages: 0,
    },
    mmsTemplateListData: {
      data: [],
      total: 0,
      pages: 0,
    },
    wechatTemplateListData: {
      data: [],
      total: 0,
      pages: 0,
    },
    subTemplateListData: {
      data: [],
      total: 0,
      pages: 0,
    },
  },

  effects: {
    *fetchUser({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getUser, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }

      yield put({
        type: 'save',
        payload: {
          userInfo: response?.data,
        },
      });
    },

    // 修改密码
    *changePassword({ payload: { values, userId }, callback }, { call, put }) {
      const response = yield call(commService.changePassword, values, userId);

      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取门店树形列表
    *getStoreTreeList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getStoreTreeList, values);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取门店树形列表
    *getBookStoreTreeList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getBookStoreTreeList, values);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //  获取区域列表
    *getRegionList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getRegionList, values);
      yield put({
        type: 'save',
        payload: {
          regionList: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取所有字典
    *getDictAll({ payload: {}, callback }, { call, put }) {
      const response = yield call(commService.getDictAll);
      if (callback && typeof callback === 'function') {
        return callback(response?.data || []);
      }

      yield put({
        type: 'save',
        payload: {
          dictAll: response?.data || [],
        },
      });
    },
    // 获取自动回复信息
    *getQueryReplyRule({ payload: { values } }, { call, put }) {
      const response = yield call(commService.getQueryReplyRule, values);
      yield put({
        type: 'save',
        payload: {
          replyRuleData: response?.data || {},
        },
      });
    },
    // 查询微信账号详情
    *getQueryAccountWeChat({ payload: { values } }, { call, put }) {
      const response = yield call(commService.getQueryAccountWeChat, values);
      yield put({
        type: 'save',
        payload: {
          weChatQueryReplyRule: response?.data || {},
        },
      });
    },
    // 查询短信模板列表
    *getQuerySmsTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getQuerySmsTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          smsTemplateListData: response?.data || {},
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    // 查询彩信模板列表
    *getQueryMmsTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getQueryMmsTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          mmsTemplateListData: response?.data || {},
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    // 查询订阅消息模板列表
    *getQueryWmpTempMsgPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(commService.getQueryWmpTempMsgPage, values);
      yield put({
        type: 'save',
        payload: {
          subTemplateListData: response?.data || {},
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    // /mms/querySmsTemplateList
    *getQueryWechatTemplatePage(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        commService.getQueryWechatTemplatePage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          wechatTemplateListData: response?.data || {},
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
